<div ngbDropdown [placement]="placement" #dropDown="ngbDropdown" [autoClose]="'outside'" [container]="container">
  <div class="cm-link" *ngIf="buttonValue" ngbDropdownAnchor (click)="toggle()">{{ buttonValue }}</div>
  <cm-icon
   *ngIf="!buttonValue"
    ngbDropdownAnchor
    (click)="toggle()"
    [name]="dropdownIcon"
    class="more-option-icon"
    [ngClass]="{'disabled-option': disabled}"
  ></cm-icon>
  <ul class="dropdown-menu" ngbDropdownMenu>
    <li ngbDropdown *ngFor="let option of options" class="nested-dropdown">
      <ng-container *ngIf="!option.options">
        <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: option }"></ng-container>
      </ng-container>
      <ng-container *ngIf="option.options">
        <div ngbDropdownToggle>
          <ng-container ngbDropdownToggle *ngTemplateOutlet="optionTemplate; context: { $implicit: option }"></ng-container>
        </div>
        <ul *ngIf="option.options" class="dropdown-menu" ngbDropdownMenu>
          <li *ngFor="let nestedOption of option.options">
            <ng-container *ngTemplateOutlet="optionTemplate; context: { $implicit: nestedOption }"></ng-container>
          </li>
        </ul>
      </ng-container>
    </li>
  </ul>
</div>

<ng-template #optionTemplate let-option>
  <div (click)="!option.options && !option.disabled && selectOption(option.id)" class="option"
       [ngClass]="{'separated-option': option?.separate, 'disabled': option.disabled}">
    <cm-icon *ngIf="option?.icon" class="option-icon" [name]="option?.icon"></cm-icon>
    <span class="option-title">{{option?.title}}</span>
  </div>
</ng-template>
